import React, { Fragment } from 'react';
import {
	Button,
	Form,
	Header,
	Segment,
	Dropdown,
	Modal,
	Checkbox,
	Grid,
	Table,
	List,
	ListItem,
	TableHeader,
	TableRow,
	TableHeaderCell,
	TableCell
} from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import { observable, computed, toJS } from 'mobx';
import { withRouter } from 'react-router-dom';
import UiShared from 'stores/UiShared';
import Auth from 'stores/Auth';
import Account from 'stores/Account';
import PrescriberPractice from 'stores/PrescriberPractice';
import Prescriber from 'stores/Prescriber';
import Practice from 'stores/Practice';
import AccountPrescriberPractice from 'stores/AccountPrescriberPractice';
import MsgStore from 'stores/MsgStore';
import MessageBox from 'components/MessageBox';
import ModalMessage from 'components/ModalMessage/index';
import uuid from 'uuid/v4';
import styles from './styles';
import API from 'api';
import _ from 'lodash';

@withRouter
@inject(root => ({
	auth: root.auth,
	user: root.auth.user,
	uiShared: root.uiShared
}))
@observer
export default class Edit extends React.Component {
	props: {
		auth?: Auth,
		user?: Account,
		uiShared?: UiShared
	};

	@computed
	get isNew() {
		return !this.ouser.id;
	}

	@observable ouser: Account = new Account();
	@observable loading: boolean = false;
	@observable showInviteDlg: boolean = false;
	@observable dropdownRoles = [];
	@observable selectedRoleId: Number = -1;
	@observable selectedRoleTypeId: Number = -1;
	@observable selectedPrescriberId: Number = -1;
	@observable pps = [];
	@observable prescribersAllDropdown = [];
	@observable userPrescribers = [];
	@observable practicesChecklist = [];
	@observable selectedPPLinkDisabled: boolean = false;
	@observable checkboxSelectAll: boolean = false;
	@observable disableSelectAll: boolean = false;
	@observable prescriberDDLReadOnly: boolean = false;

	msgStore = new MsgStore();

	componentDidMount = async () => {
		try {
			const { match } = this.props;
			this.loading = true;
			if (match.params.id === '0') {
				this.ouser = new Account();
				this.ouser.password = uuid();
				this.loading = false;
			} else {
				this.ouser = await Account.loadById(parseInt(match.params.id));
				this.populateUserPrescribers();
			}
			this.dropdownRoles = [
				{ name: 'manager', id: 1 },
				{ name: 'user', id: 2 },
				{ name: 'viewer', id: 4 }
			];
			this.selectedRoleId =
				match.params.id === '0' ? this.dropdownRoles[0]?.id : this.ouser?.Roles?.[0]?.roleId;

			await this.getAllPrescriberPractices();
			this.populateAllPrescribersDDL();
		} finally {
			this.loading = false;
		}
	};

	getAllPrescriberPractices = async () => {
		const pps = await API.get(
			`/PrescriberPractices?filter=${JSON.stringify({
				where: { disabled: false },
				include: [
					{
						relation: 'Practice',
						scope: {
							fields: ['id', 'practiceName', 'disabled']
						}
					},
					{
						relation: 'Prescriber',
						scope: {
							fields: ['id', 'prescriberName', 'prescriberSurname', 'prescriberNo', 'disabled']
						}
					}
				]
			})}`
		);
		this.pps = pps.map(el => new PrescriberPractice(el));
	};

	populateAllPrescribersDDL = () => {
		const prescribers = [];
		this.pps.forEach(o => {
			const foundPrescriber = _.find(prescribers, p => p.id === o.Prescriber.id);
			if (!foundPrescriber && !o.Prescriber.disabled) {
				prescribers.push(o.Prescriber);
			}
		});
		const dropdownPrescribers = prescribers.map((el, idx) => {
			return {
				text: `${el.prescriberName} ${el.prescriberSurname}`,
				value: el.id,
				key: idx + 1
			};
		});
		const first = {
			text: 'ALL PRESCRIBERS',
			value: 0,
			key: 0
		};
		this.prescribersAllDropdown = [first].concat(dropdownPrescribers);
	};

	shortenPracticeName = (practiceName: string) => {
		if (!practiceName) return;
		const idx = practiceName.indexOf('-');
		return idx === -1 ? practiceName.split(' ')[0] : practiceName.slice(0, idx);
	};

	populateUserPrescribersAll = () => {
		const userPrescribers = [];
		this.pps.forEach(o => {
			const pPractice = {
				id: o.Practice.id,
				ppId: o.id,
				name: this.shortenPracticeName(o.Practice.practiceName)
			};
			const foundPrescriber = _.find(userPrescribers, p => p.id === o.Prescriber.id);
			if (foundPrescriber) {
				const foundPractice = _.find(foundPrescriber.practices, obj => obj.id === o.Practice.id);
				if (!foundPractice) {
					foundPrescriber.practices.push(pPractice);
				}
			} else {
				userPrescribers.push({
					id: o.Prescriber.id,
					no: o.Prescriber.prescriberNo,
					name: `${o.Prescriber.prescriberName} ${o.Prescriber.prescriberSurname}`,
					practices: [pPractice]
				});
			}
		});
		this.userPrescribers = userPrescribers;
	};

	populateUserPrescribers = () => {
		if (!this.ouser?.id) return;

		const ouserAPPs = toJS(this.ouser?.AccountPrescriberPractices) || [];
		const userPrescribers = [];
		ouserAPPs.forEach(o => {
			const pp = o.PrescriberPractice;
			const prescriber = pp.Prescriber;
			const practice = pp.Practice;
			//practice object
			const pPractice = {
				id: practice.id,
				appId: o.id,
				ppId: o.prescriberPracticeID,
				name: this.shortenPracticeName(practice.practiceName),
				disabled: o.disabled
			};
			const foundPrescriber = _.find(userPrescribers, obj => obj.id === prescriber.id);
			if (foundPrescriber) {
				const foundPractice = _.find(foundPrescriber.practices, obj => obj.id === practice.id);
				if (!foundPractice) {
					foundPrescriber.practices.push(pPractice);
				}
			} else {
				//prescriber object
				userPrescribers.push({
					id: prescriber.id,
					no: prescriber.prescriberNo,
					name: `${prescriber.prescriberName} ${prescriber.prescriberSurname}`,
					practices: [pPractice]
				});
			}
		});
		this.userPrescribers = userPrescribers;
	};

	save = async () => {
		this.msgStore.clear();
		let uiShared = this.props.uiShared;
		const { isNew, selectedRoleId, ouser } = this;
		try {
			uiShared.showModal('Saving...');
			if (isNew) {
				if (selectedRoleId === 1) {
					this.ouser.createManagerRole = true;
				} else if (selectedRoleId === 4) {
					this.ouser.createViewerRole = true;
				}
			}
			this.ouser.isRaNumberUnique = true;
			if (ouser.raNumber) {
				let raNumberUnique = true;
				const users = await Account.loadByRaNumber(ouser.raNumber);
				if (users && users.length > 0) {
					if (this.isNew) {
						raNumberUnique = false;
					} else {
						const isCurrent = users.length === 1 && users[0].id === ouser.id;
						if (!isCurrent) {
							raNumberUnique = false;
						}
					}
				}
				this.ouser.isRaNumberUnique = raNumberUnique;
			}
			this.ouser.isRaNumberRequired = selectedRoleId === 1 || selectedRoleId === 2;

			const ouserAPPs = toJS(this.ouser?.AccountPrescriberPractices) || [];
			//iterate over userPrescribers and userPrescribers.practices, and either add or set disabled
			const userPrescribers = this.userPrescribers;
			for (let i = 0; i < userPrescribers.length; i++) {
				for (let j = 0; j < userPrescribers[i].practices?.length; j++) {
					const practice = userPrescribers[i].practices[j];
					const ppIdToAdd = practice.ppId;
					const idx = _.findIndex(ouserAPPs, {
						prescriberPracticeID: ppIdToAdd
					});
					if (idx === -1) {
						this.ouser.AccountPrescriberPractices.push(
							new AccountPrescriberPractice({
								prescriberPracticeID: ppIdToAdd
							})
						);
					} else {
						const item = this.ouser.AccountPrescriberPractices[idx];
						item.disabled = !!practice.disabled;
					}
				}
			}

			await this.ouser.update();
			await this.ouser.reload();
			if (isNew) {
				this.showInviteDlg = true;
			}
			this.msgStore.setInfo('The record was saved.');
		} catch (err) {
			console.log(err);
			this.msgStore.setError(err);
		} finally {
			uiShared.hideModal();
		}
	};

	sendInvite = async () => {
		const { uiShared } = this.props;
		try {
			this.showInviteDlg = false;
			uiShared.showModal('Sending the invitation...');
			this.ouser.invitationSent = true;
			await this.ouser.update();
			await this.ouser.reload();
			await Auth.passwordReset(this.ouser.email, 'SAM - Password Setup Request');
			uiShared.showModal('The invitation was sent', {
				actions: [
					<Button key="1" onClick={() => uiShared.hideModal()}>
						Close
					</Button>
				]
			});
			this.msgStore.clear();
		} catch (err) {
			this.ouser.invitationSent = false;
			uiShared.hideModal();
			this.msgStore.setError('The invitation was not sent. ' + err);
		}
	};

	resetModal = () => {
		this.practicesChecklist = [];
		this.checkboxSelectAll = false;
		this.disableSelectAll = false;
		this.prescriberDDLReadOnly = false;
		this.msgStore.clear();
	};

	populatePracticesForPrescriber = () => {
		if (this.selectedPrescriberId < 1) return;

		//get all practices for the prescriber
		const practicesForPrescriberAll = this.pps?.filter(
			el =>
				el.prescriberID === this.selectedPrescriberId &&
				!el.Practice.disabled &&
				!el.Prescriber.disabled
		);
		//get currently active practices for the prescriber
		const activePractices =
			_.find(this.userPrescribers, o => o.id === this.selectedPrescriberId)?.practices || [];

		this.practicesChecklist = practicesForPrescriberAll.map((o, idx) => {
			const practice = _.find(activePractices, p => p.id === o.Practice.id);
			return {
				id: o.Practice.id,
				ppId: o.id,
				practiceName: o.Practice.practiceName,
				checked: practice ? true : false,
				disabled: !!practice?.disabled,
				key: idx,
				appId: practice?.appId
			};
		});
	};

	render() {
		const { history } = this.props;
		let {
			ouser,
			selectedRoleId,
			checkboxSelectAll,
			userPrescribers,
			isNew,
			disableSelectAll,
			prescribersAllDropdown
		} = this;

		const opt = toJS(prescribersAllDropdown);
		const prescribersDropdown = opt.filter(o => {
			const alreadySelected = _.find(userPrescribers, p => p.id === o.value);
			return !!!alreadySelected;
		});

		return (
			<Segment loading={this.loading}>
				<Header as="h1">{ouser.id ? `Edit user - ${ouser.fullName}` : 'Add new user'}</Header>
				<Grid>
					<Grid.Column style={{ maxWidth: 750 }}>
						<Form>
							<Form.Group className={styles.formGroup}>
								<Form.Input
									label="First Name"
									placeholder="First Name"
									value={ouser.firstName || ''}
									onChange={e => (ouser.firstName = e.target.value?.toUpperCase())}
									width={8}
								/>
								<Form.Input
									label="Last Name"
									placeholder="Last Name"
									value={ouser.lastName || ''}
									onChange={e => (ouser.lastName = e.target.value?.toUpperCase())}
									width={8}
								/>

								<Form.Input
									label="Mobile"
									value={ouser.phoneNumber || ''}
									onChange={e => (ouser.phoneNumber = e.target.value)}
									width={8}
								/>
								<Form.Input
									label="E-mail"
									value={ouser.email || ''}
									onChange={e => (ouser.email = e.target.value)}
									width={8}
								/>

								<Form.Field width={8}>
									<label>Role</label>
									<Dropdown
										selection
										placeholder="Select role"
										value={selectedRoleId}
										onChange={(e, data) => {
											this.selectedRoleId = data.value;
											if (!isNew) {
												ouser.updatedRoleId = data.value;
											}
										}}
										options={this.dropdownRoles.map(r => ({ text: r.name, value: r.id }))}
										fluid
									/>
								</Form.Field>
								<Form.Input
									label="RA Number"
									value={ouser.raNumber || ''}
									onChange={e => (ouser.raNumber = e.target.value)}
									width={8}
								/>
								<div className={styles.togglesCnt}>
									<Form.Field width={16} className={styles.toggleMargin}>
										<Checkbox
											label="Disable User"
											checked={ouser.disabled || false}
											onChange={() => (ouser.disabled = !ouser.disabled)}
											toggle
										/>
									</Form.Field>
									<Form.Field width={16} className={styles.toggleMargin}>
										<Checkbox
											label="Disable 2FA"
											checked={ouser.simpleLoginAllowed || false}
											onChange={() => (ouser.simpleLoginAllowed = !ouser.simpleLoginAllowed)}
											toggle
										/>
									</Form.Field>
									<div className={styles.toggleHeader}>
										<h3>Receive notifications</h3>
									</div>
									<Form.Field width={16}>
										<Checkbox
											label="SMS"
											checked={ouser.alertSMS || false}
											onChange={() => (ouser.alertSMS = !ouser.alertSMS)}
											toggle
										/>
									</Form.Field>
									<Form.Field width={16} className={styles.toggleMargin}>
										<Checkbox
											label="Email"
											checked={ouser.alertEmail || false}
											onChange={() => (ouser.alertEmail = !ouser.alertEmail)}
											toggle
										/>
									</Form.Field>
									<Form.Field width={16} className={styles.toggleMargin}>
										<Checkbox
											label="Scheduled Reminders"
											checked={ouser.scheduledReminders || false}
											onChange={() => (ouser.scheduledReminders = !ouser.scheduledReminders)}
											toggle
										/>
									</Form.Field>
								</div>
							</Form.Group>

							<Segment>
								<Form.Field>
									<label>Practice/Prescriber Links</label>
									<div className={styles.btnLink}>
										<Button
											primary
											onClick={() => {
												this.resetModal();
												this.selectedPrescriberId = 0;
											}}
										>
											Link to Practice/Prescriber
										</Button>
									</div>
								</Form.Field>
								<div>
									{userPrescribers.length > 0 && (
										<Table basic="very" compact="very">
											<Table.Header>
												<Table.Row>
													<Table.HeaderCell>Prescriber Name</Table.HeaderCell>
													<Table.HeaderCell>Prescriber Number</Table.HeaderCell>
													<Table.HeaderCell>Practices</Table.HeaderCell>
													<Table.HeaderCell>Actions</Table.HeaderCell>
												</Table.Row>
											</Table.Header>
											<Table.Body>
												{userPrescribers.map((el, idx) => {
													return (
														<Table.Row key={idx}>
															<Table.Cell>{el?.name}</Table.Cell>
															<Table.Cell>{el?.no}</Table.Cell>
															<Table.Cell>
																{el?.practices
																	.filter(o => !o.disabled)
																	.map(o => o.name)
																	.join('; ')}
															</Table.Cell>
															<Table.Cell>
																<Button
																	icon="edit"
																	size="mini"
																	label="Edit"
																	primary
																	onClick={() => {
																		this.prescriberDDLReadOnly = true;
																		this.selectedPrescriberId = el?.id;
																		this.populatePracticesForPrescriber();
																	}}
																/>
															</Table.Cell>
														</Table.Row>
													);
												})}
											</Table.Body>
										</Table>
									)}
								</div>
							</Segment>

							<div className={styles.buttonsRow}>
								<Button primary onClick={() => this.save()} floated="left">
									Save
								</Button>
								<Button onClick={() => history && history.goBack()} floated="left">
									Back
								</Button>
								{!this.isNew && (
									<Fragment>
										<Button primary floated="right" onClick={() => (this.showInviteDlg = true)}>
											Invite
										</Button>
									</Fragment>
								)}
								<div className={styles.clear} />
							</div>
						</Form>
					</Grid.Column>
				</Grid>

				<MessageBox msgStore={this.msgStore} />
				<ModalMessage open={!!this.modalMessage} message={this.modalMessage} showLoader />
				<Modal size="mini" open={this.showInviteDlg} onClose={() => (this.showInviteDlg = false)}>
					<Modal.Header>Invite</Modal.Header>
					<Modal.Content>
						<p>
							Do you wish to send invitation to {ouser.firstName} {ouser.lastName}?
						</p>
					</Modal.Content>
					<Modal.Actions>
						<Button negative onClick={() => (this.showInviteDlg = false)}>
							No
						</Button>
						<Button
							positive
							icon="checkmark"
							labelPosition="right"
							content="Yes"
							onClick={() => this.sendInvite()}
						/>
					</Modal.Actions>
				</Modal>

				<Modal
					open={this.selectedPrescriberId > -1}
					onClose={() => {
						this.resetModal();
					}}
					closeOnDimmerClick={false}
				>
					<Modal.Header>Link to Prescriber/Practice</Modal.Header>
					<Modal.Content>
						<Form>
							<div>
								{!this.prescriberDDLReadOnly && (
									<Form.Field width={8}>
										<label>Select Prescriber</label>
										<Dropdown
											selection
											disabled={this.prescriberDDLReadOnly}
											search
											placeholder="Select Prescriber"
											value={this.selectedPrescriberId}
											onChange={(e, data) => {
												this.selectedPrescriberId = data.value;
												this.resetModal();
												this.populatePracticesForPrescriber();
											}}
											options={prescribersDropdown}
											fluid
										/>
									</Form.Field>
								)}

								<Table basic="very" compact="very" singleLine>
									<TableHeader />
									<Table.Body>
										{this.prescriberDDLReadOnly && (
											<TableRow>
												<TableCell>
													<Form.Input
														label="Prescriber"
														value={
															_.find(this.prescribersAllDropdown, {
																value: this.selectedPrescriberId
															})?.text || ''
														}
														width={8}
														readOnly
													/>
												</TableCell>
												<TableCell>
													{this.prescriberDDLReadOnly &&
														!!_.find(this.practicesChecklist, o => o.appId) && (
															<Checkbox
																label="Disable All"
																checked={disableSelectAll}
																onChange={() => {
																	this.disableSelectAll = !this.disableSelectAll;
																	this.practicesChecklist.forEach(o => {
																		if (o.appId) {
																			o.disabled = this.disableSelectAll;
																		}
																	});
																}}
																toggle
															/>
														)}
												</TableCell>
											</TableRow>
										)}

										{this.pps.length > 0 && this.selectedPrescriberId > 0 && (
											<Fragment>
												<TableRow colSpan={2}>
													<TableCell style={{ borderTop: '0px', paddingTop: '15px' }}>
														<span style={{ fontSize: '0.93em', fontWeight: 'bold' }}>
															Select Practice(s)
														</span>
													</TableCell>
												</TableRow>
												<TableRow colSpan={2}>
													<TableCell style={{ borderTop: '0px' }}>
														<Checkbox
															label={'SELECT ALL PRACTICES'}
															className={styles.boldLabel}
															checked={checkboxSelectAll}
															onChange={() => {
																this.checkboxSelectAll = !this.checkboxSelectAll;
																const val = this.checkboxSelectAll;
																this.practicesChecklist.forEach(o => {
																	if (!o.appId) {
																		o.checked = val;
																	}
																});
															}}
															style={{ width: '100%' }}
														/>
													</TableCell>
												</TableRow>

												{this.practicesChecklist.map((el, idx) => {
													return (
														<TableRow key={idx + 1}>
															<TableCell style={{ borderTop: '0px', paddingRight: '40px' }}>
																<Checkbox
																	label={el?.practiceName}
																	className={styles.labelDisabled}
																	readOnly={!!el?.appId}
																	checked={el?.checked}
																	onChange={() => {
																		el.checked = !el.checked;
																		if (!el.checked) {
																			this.checkboxSelectAll = false;
																		}
																	}}
																	style={{ width: '100%' }}
																/>
															</TableCell>
															<TableCell style={{ borderTop: '0px', width: '100%' }}>
																{el?.appId && (
																	<Checkbox
																		label="Disable Link"
																		checked={el.disabled || false}
																		onChange={() => (el.disabled = !el.disabled)}
																		toggle
																	/>
																)}
															</TableCell>
														</TableRow>
													);
												})}
											</Fragment>
										)}
									</Table.Body>
								</Table>
							</div>
						</Form>
					</Modal.Content>
					<Modal.Actions>
						<Button
							negative
							onClick={() => {
								this.resetModal();
								this.selectedPrescriberId = -1;
							}}
						>
							Cancel
						</Button>
						<Button
							primary
							floated="left"
							disabled={
								this.selectedPrescriberId > 0 && !_.find(this.practicesChecklist, { checked: true })
							}
							onClick={() => {
								//if ALL PRESCRIBERS -> generate all combinations
								if (this.selectedPrescriberId === 0) {
									this.populateUserPrescribersAll();
								} else {
									let prescriber = _.find(
										this.userPrescribers,
										o => o.id === this.selectedPrescriberId
									);
									const addNew = !prescriber;
									if (addNew) {
										const pData = _.find(toJS(this.pps), o => {
											return o.Prescriber.id === this.selectedPrescriberId;
										});
										prescriber = {
											id: this.selectedPrescriberId,
											no: pData.Prescriber.prescriberNo,
											name: `${pData.Prescriber.prescriberName} ${
												pData.Prescriber.prescriberSurname
											}`,
											practices: []
										};
									}
									const practices = prescriber.practices;
									//iterate over all possible practices
									this.practicesChecklist.forEach(p => {
										const foundPractice = _.find(practices, o => o.id === p.id);
										if (p.checked) {
											//if checked
											if (!foundPractice) {
												//and not found in table data structure
												practices.push({
													id: p.id,
													name: this.shortenPracticeName(p.practiceName),
													ppId: p.ppId
												});
											} else {
												//checked and found in table data structure
												//updating existing
												if (foundPractice.appId) {
													foundPractice.disabled = p.disabled;
												}
											}
										} else {
											// unchecked
											if (foundPractice) {
												//removing
												const idx = _.findIndex(practices, {
													id: p.id
												});
												practices.splice(idx, 1);
											}
										}
									});
									if (addNew) {
										this.userPrescribers.push(prescriber);
									}
								}
								this.resetModal();
								this.selectedPrescriberId = -1;
							}}
						>
							Save
						</Button>
					</Modal.Actions>
				</Modal>
			</Segment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/routes/Admin/Users/Edit.js